import React, { useState } from "react";

import LazyLoad from "react-lazyload";
import { isMobile } from "react-device-detect";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

function SmallImage({ basketItem, index2, item }) {
  const [isImageLoad, setIsImageLoad] = useState(false);
  return (
    <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
      <LazyLoad>
        {!isImageLoad && (
          <div
            className="my-0 ml-1 "
            style={
              !isImageLoad
                ? {
                    height: "35px",
                    width: "35px",
                  }
                : {
                    height: "0",
                    width: "0",
                  }
            }
          >
            <Skeleton height="100%" className="mt-0 " />
          </div>
        )}
        <div
          className=" my-1  py-0"
          style={!isImageLoad ? { width: "0", height: "0" } : {}}
        >
          <img
            height={!isImageLoad ? 0 : ""}
            width={!isImageLoad ? 0 : ""}
            onLoad={() => {
              setIsImageLoad(true);
            }}
            src={
              process.env.REACT_APP_API_URL +
              basketItem.amusementServiceImageUrl +
              (isMobile ? "?width=40" : "")
            }
            alt={basketItem.amusementServiceName}
            style={{ width: "35px", height: "35px" }}
            className="rounded-circle"
          />
        </div>
      </LazyLoad>
    </SkeletonTheme>
  );
}

export default SmallImage;
